export default "__VITE_ASSET__B6107Qo$__"